import { useContext } from "react";
import { useSelector } from "react-redux";
import { Boundaries } from "@planzone/core";
import { CoreContext } from "../context";
import { Identifiable, ProjectExpense } from "@planzone/dto";

interface ViewModel {
  isRequestSuccess: boolean;
  isRequestFailure: boolean;
  isRequestPending: boolean;
  editProjectExpense(
    request: Boundaries["editProjectExpense"]["request"],
  ): void;
}

function useEditProjectExpense(
  projectExpense: Identifiable<ProjectExpense>,
): ViewModel {
  const { selector, core } = useContext(CoreContext);

  return {
    isRequestPending: useSelector(() =>
      selector.isEditProjectExpenseRequestPending(projectExpense),
    ),
    isRequestSuccess: useSelector(() =>
      selector.isEditProjectExpenseRequestSuccess(projectExpense),
    ),
    isRequestFailure: useSelector(() =>
      selector.isEditProjectExpenseRequestFailure(projectExpense),
    ),
    editProjectExpense: core.editProjectExpense,
  };
}

export { useEditProjectExpense };
